/* src/app/components/dialogs/select-filter-new/field-search/field-search.component.scss */
div mat-icon {
  align-self: center;
}
mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: rgba(0, 0, 0, 0.5);
  --outlined-text-field-hover-outline-color: rgba(0, 0, 0, 0.7);
}
:host-context(.dark-theme) mat-form-field[appearance=outline] {
  --outlined-text-field-outline-color: rgba(255, 255, 255, 0.4);
  --outlined-text-field-hover-outline-color: rgba(255, 255, 255, 0.5);
}
/*# sourceMappingURL=field-search.component.css.map */
